import { useMsal } from "@azure/msal-react";
import createAxiosInstance from "../utils/axiosCustomize";

const SSOService = () => {
    const { instance, accounts } = useMsal();
    const axiosInstance = createAxiosInstance(instance, accounts);

    const getSSO = () => {
        return axiosInstance.get("/SSO")
    }

    const postLogout = () => {
        return axiosInstance.post("/SSO/logout")
    }

    return { getSSO, postLogout }
}

export default SSOService;
